<template>
  <div>
    <div class="form-group">
      <b>Denumire poziție de catalog</b>
      <input
        v-model="productName"
        class="vInput form-disabled"
        type="text"
        disabled
      />
    </div>

    <div class="form-flex form-adapt-2">
      <div class="form-group">
        <b>Tip poziție catalog</b>
        <v-select
          :options="productTypes"
          label="name"
          v-model="selectedProductType"
        />
      </div>
      <div class="form-group">
        <b>Unitatea de măsură</b>
        <v-select
          v-model="selectedMeasureUnits"
          label="name"
          :filter="(a, b) => fuseFilter(a, b, 'name')"
          :options="measureUnits"
        />
      </div>
    </div>

    <template v-if="apiLoading">
      <i class="fas fa-sync fa-spin fa-2x"></i>
    </template>
    <template v-else>
      <div class="form-group">
        <b>Cod CPV</b>
        <v-select-infinite
          v-model="selected"
          label="cpvCode,name"
          :startup="!readonly"
          :apiModule="apiModule"
          :apiOptions="{ prepareSearch }"
          :totalOptions="totalOptions"
          :totalRecordsCount="totalRecordsCount"
          :no-drop="readonly"
          :clearable="!readonly"
          :reloadCount="reloadCount"
          :appendToBody="false"
          :overflowPrevent="true"
        >
        </v-select-infinite>
      </div>
    </template>

    <div class="form-group colFlexs MTmobile1" style="flex-grow: 1">
      <b style="line-height: 1.2">Descriere poziție de catalog</b>
      <pre
        class="mobileClampFontSize"
        style="height: 100%; margin: 0; white-space: pre-wrap"
        v-html="itemDescription"
      ></pre>
    </div>

    <div class="form-group">
      <b>Produse similare</b>
      <div
        ref="table_match_products"
        class="CTTableParent"
        style="flex-grow: 1; min-height: 200px; margin-bottom: 1rem"
      >
        <div
          ref="Table3"
          class="CTTable"
          style="height: 100%"
          :style="`max-height:${tableHeight}px;`"
        >
          <table
            class="custom_docTb notFixedTableForMobile"
            :class="{ CTLoading: !searchState && productName.length > 2 }"
            style="height: 100%"
          >
            <thead>
              <th style="width: 5rem">Nr.</th>
              <th>Nume produs</th>
              <th>Denumire CPV</th>
              <th>Cod CPV</th>
              <th>Unitate de măsură</th>
            </thead>
            <tbody>
              <td
                v-if="productName.length < 3"
                style="border-bottom: 0"
                colspan="5"
              >
                <h4 style="color: #df302d; cursor: default" align="center">
                  <i class="fas fa-exclamation-triangle"></i> Căutarea trebuie
                  să conțină minim 3 caractere
                </h4>
              </td>
              <template v-else>
                <td v-if="!searchState" colspan="5">
                  <div
                    align="center"
                    style="font-size: 4.5rem; margin-top: 0.25rem"
                  >
                    <i class="fas fa-sync fa-spin"></i>
                  </div>
                </td>
                <td v-else-if="searchState === 1" colspan="5">
                  <h4 align="center">Nu a fost găsit nici un produs similar</h4>
                </td>
                <tr v-else v-for="(row, i) in products" :key="row.cpvCode">
                  <td style="text-align: center">
                    {{ i + 1 + addPagesCount }}
                  </td>
                  <td>{{ row.name }}</td>
                  <td>{{ row.cpvName }}</td>
                  <td>{{ row.cpvCode }}</td>
                  <td>{{ row.measurementUnit }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div
      v-if="!isNaN(productCount)"
      style="
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
      "
    >
      <div>
        <b>Nr. total de rezultate: {{ productCount }}</b>
      </div>
      <div>
        <div id="Pages" style="margin-right: 0.5rem; display: flex">
          <div v-for="page in pages" :key="page">
            <a
              @click.prevent="selectPage(page)"
              href="#"
              class="PageBtn"
              :class="{
                PageActive: page === currPage,
                PageDisabled: !parseInt(page),
              }"
            >
              <span>{{ page }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CPV_CATEGORY_PAGINATED,
  PRODUCTS_MATCH,
  MEASUREMENT_UNIT,
} from "@/api.js";
const elementResizeDetectorMaker = require("element-resize-detector");
const erdUltraFast = elementResizeDetectorMaker({
  strategy: "scroll",
});
export default {
  name: "CodCpvSelect",
  props: {
    initial: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      apiModule: CPV_CATEGORY_PAGINATED,
      totalOptions: [],
      totalRecordsCount: 0,
      selected: this.initial.cpvCategory,
      productTypes: [
        { name: "Produse", id: 1 },
        { name: "Servicii", id: 2 },
        { name: "Lucrări", id: 3 },
      ],
      newData: this.initial,
      selectedProductType: {},
      productName: this.initial.name,
      measureUnits: [],
      selectedMeasureUnits: {},
      reloadCount: 0,
      getSelectSchema() {
        return {
          value: null,
          id: typeof this.makeid == "function" ? this.makeid(8) : Date.now(),
          excluded: false,
          canEdit: true,
        };
      },
      currPage: 1,
      productCount: 0,
      products: [false],
      viewRows: 25,
      tableHeight: NaN,
      apiLoading: false,
    };
  },

  watch: {
    selected: {
      handler(val) {
        if (val) {
          this.selectedProductType = this.productTypes.find(
            (el) => el.id == val.cpvType
          );
        }
        this.newData = { ...this.newData, cpvCategory: val };
        this.$emit("input", this.newData);
      },
    },
    selectedMeasureUnits: {
      handler(val) {
        this.newData = { ...this.newData, measurementUnit: val };
        this.$emit("input", this.newData);
      },
    },
    productName: {
      handler(val) {
        this.newData = { ...this.newData, name: val };
        this.$emit("input", this.newData);
        this.matchProduts();
      },
    },
    selectedProductType(val) {
      this.reloadCount++;
    },
    deep: true,
    immediate: true,
  },
  computed: {
    itemDescription() {
      return this.selected
        ? `<b>Denumire</b>: ${this.selected.cpvCode} - ${this.selected.name}\n<b>Diviziunea</b>: ${this.selected.division}\n<b>Grupul</b>: ${this.selected.group}\n<b>Clasa</b>: ${this.selected.class}\n<b>Categoria</b>: ${this.selected.category}`
        : "";
    },
    sch() {
      return this.search.trim();
    },
    searchState() {
      if (!this.products.length) return false;
      if (!this.products[0]) return 1;
      return true;
    },
    pages() {
      return (
        this.pagination(
          this.currPage,
          Math.ceil(this.productCount / this.viewRows),
          4
        ) || []
      );
    },
    addPagesCount() {
      return (this.currPage - 1) * this.viewRows;
    },
  },

  methods: {
    async getMeasureUnits() {
      let x = await MEASUREMENT_UNIT();
      return x.data.result;
    },
    updateTableHeight() {
      window.requestAnimationFrame(() => {
        const x = +this.$refs["table_match_products"]?.offsetHeight;
        this.tableHeight = isNaN(x) ? 400 : Math.max(500, x);
      });
    },
    getBudgetLabel(x) {
      return x?.budgetClasification?.name || "";
    },
    addOption() {
      if (!this.canAdd) return;

      this.selected.push(this.getSelectSchema());
    },
    prepareSearch(x) {
      return [
        this.selectedProductType.id,
        ["columnsOr", `cpvCode,name,division,group,class,category||${x}`],
      ];
    },
    selectPage(x) {
      x = parseInt(x);
      if (!x || x == this.currPage) return;
      this.currPage = x;
      this.matchProduts();
    },

    matchProduts() {
      if (this.productName.length < 3) {
        return;
      }

      this.products = [];

      PRODUCTS_MATCH(
        this.currPage,
        this.viewRows,
        `search=${this.productName}&id=${this.initial.id}`
      ).then((res) => {
        if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
          this.productCount = res.data.recordsQuantity;
          this.products = res.data.result.length ? res.data.result : [false];
        } else {
          this.products = [false];
          this.$toastr.e("Nu sau încărcat datele.");
        }
      });
    },
    async convertedMuData() {
      this.selectedMeasureUnits = {
        id: this.initial.measurementUnit.id,
        name: `${this.initial.measurementUnit.shortName} — „${this.initial.measurementUnit.description}”`,
      };

      const units = await this.getMeasureUnits();

      this.measureUnits = units.map((e) => ({
        id: e.id,
        name: `${e.shortName} — „${e.description}”`,
      }));
    },
  },

  created() {
    this.matchProduts();
    this.convertedMuData();

    if (this.initial.cpvCategory) {
      this.selectedProductType = this.productTypes.find(
        (el) => el.id == this.initial.cpvCategory.cpvType
      );
    }

    const el = this.$refs["table_match_products"];
    if (el) {
      erdUltraFast.listenTo(el, this.updateTableHeight);
    }

    this.updateTableHeight();

    this.$emit("input", this.newData);
  },
};
</script>

<style scoped>
table {
  transition: opacity 250ms;
}
#Pages .PageBtn {
  position: relative;
  margin-right: 0.25rem;
  overflow: hidden;
}
#Pages .PageBtn > * {
  position: relative;
  z-index: 1;
}
#Pages .PageBtn:after {
  position: absolute;
  display: block;
  content: "";
  top: 100%;
  left: 0;
  right: 0;
  height: 100%;
  background-color: #c3c3c3;
  transition: top 200ms;
  z-index: 0;
}
#Pages .PageBtn:hover:after {
  top: 0;
}
#Pages .PageBtn:hover {
  color: #fff;
}
.PageBtn {
  display: inline-block;
  padding: 0 0.5rem;
}
.PageDisabled {
  color: #000;
  pointer-events: none;
}
.PageActive {
  background-color: #c3c3c3;
  color: #fff;
  pointer-events: none;
}
</style>
<style src="@/assets/CatalogSelect.css"></style>
